<template>
    <div    class="z-50">
        <slide-over-panel     v-model:show="$data._show"
                        v-model:scroll-to-y="$data._modalScroll"
                        @update:show="updateShow($data._show)">
        >
            <template   #title>
                Select Series
            </template>
            <template   #content>
                <!-- Search Box to search the series -->
                <div>
                    <floating-input     label="Search"
                                        id="search"
                                        v-model:value="search"
                    ></floating-input>
                </div>

                <div    class="text-red-500">
                    <div    v-if="errorMultipleScalingProfiles">
                        Can not have more than two scaling profiles Remove all the points
                        from the existing scaling profile to add a different one.
                    </div>
                </div>

                <!-- Just list all Series -->
                <div    v-if="hasPoints">
                    <div    v-for="(pointsInProfile, scalingProfileId) in pointsByScalingProfile">
                      <div
                        v-if="isScalingProfileVisible(scalingProfileId)"
                        class="my-4 rounded-md border-2 border-gray-400 py-0">
                        <!-- Scaling Profile Row -->
                        <div    class="flex items-center justify-between py-2 px-3">
                          <span   class="font-semibold">
                            {{ scalingProfiles[scalingProfileId].name }}
                          </span>

                          <div    class="flex items-center justify-between w-3/5">
                            <!-- Button to Add all points to graph -->
                            <div    class="mx-1 w-1/2">
                              <button-blue-secondary
                                @click="addAllOfAScalingProfile(scalingProfileId)">
                                Add All Points
                              </button-blue-secondary>
                            </div>

                            <!-- Button to Remove all points from graph -->
                            <div    class="mx-1 w-1/2">
                              <button-blue-secondary
                                @click="removeAllOfAScalingProfile(scalingProfileId)">
                                Remove All Points
                              </button-blue-secondary>
                            </div>
                          </div>
                        </div>

                        <!-- Series In the Scaling Profile -->
                        <ul
                          class="rounded-md border border-gray-300">
                          <template v-for="(point, index) in pointsInProfile">
                            <li     v-if="isPointVisible(point.id)"
                                    class="flex flex-inline justify-between border border-gray-300 border-solid p-2 px-3"
                                    @click="toggleSeries(point)"
                            >
                              <!-- Checkbox for the series -->
                              <span>
                                <input  id="comments"
                                        v-model="seriesStatus[point.id]"
                                        name="comments"
                                        type="checkbox"
                                        class="focus:ring-blue-500 h-4 w-4 text-indigo-600 border-blue-300 rounded"
                                >
                              </span>

                              <!-- Series Name & Serial Number -->
                              <span>
                                {{ point.name }} ({{ point.serialNumber }})
                              </span>
                            </li>
                          </template>

                        </ul>
                      </div>

                    </div>
                </div>
            </template>
        </slide-over-panel>
    </div>
</template>

<script>

import SlideOverPanel from "@/components/elements/SlideOverPanel";

import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import {am4Settings} from "@/mixins/am4charts/am4Settings";

import _ from 'lodash'
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary";
import FloatingInput from "@/components/elements/FloatingInput";

export default {
    name: "SelectSeriesModal",
    mixins: [iconNamesMixin],
    components: {FloatingInput, ButtonBlueSecondary, SlideOverPanel},
    props: {
        showModal: Boolean,
        scalingProfiles: [Object, Array],
        points: Object,
        seriesVisible: Array,

        errorMultipleScalingProfiles: Boolean,
    },
    data() {
        return {
            _show: false,
            _modalScroll: 1,
            seriesStatus: {},
            search: '',
            showSeries: {},

            // ScalingProfileId => [Series W/ Scaling Profile]
            pointsByScalingProfile: {},
        }
    },
    created() {
        this.resetPoints()
    },
    mounted() {
        this.seriesStatus = {}
        this.pointsByScalingProfile = {}
        _.each(this.seriesStatus, (series, id) => {
            this.showSeries[id] = false
        })

        this.rebuildPointsByScalingProfile()
    },
    methods: {
        toggleSeries(point, override = null) {
            this.seriesStatus[point.id] = _.isNil(override)
                    ? !this.seriesStatus[point.id]
                    : override
            this.$forceUpdate()

            let aPointWasAdded = false
            let tmp = []
            _.each(this.seriesStatus, (item, id) => {
                if (item) {
                    tmp.push(`${id}`)
                    aPointWasAdded = true
                }
            })

            if (aPointWasAdded) {
                this.$emit(`update:pointsByScalingProfile`, false)
                this.fathomGoalTrackAddSeries()
            }

            this.$emit(`update:seriesVisible`, tmp)
        },
        addAllOfAScalingProfile(scalingProfileId) {
            _.each(this.pointsByScalingProfile[scalingProfileId], point => {
                // Only Add Point if it is currently visible.
                if (this.isPointVisible(point.id)) {
                    this.toggleSeries(point, true)
                }
            })
        },
        removeAllOfAScalingProfile(scalingProfileId) {
            _.each(this.pointsByScalingProfile[scalingProfileId], point => {
                this.toggleSeries(point, false)
            })
        },
        openPoint(id, newTab = false) {
            let route = `/${this.getCompanyId()}/meters/${id}`
        },
        updateShow(show) {
            this.$data._show = show
            this.$emit('update:showModal', this.$data._show)
        },
        resetPoints() {
            _.each(this.points, (point, key) => {
                this.seriesStatus[point.id] = _.indexOf(this.seriesVisible, point.id) !== -1
            })
            _.each(this.seriesStatus, (series, id) => {
                this.showSeries[id] = true
            })
        },
        isPointVisible(id) {
            if (!_.has(this.showSeries, id)) {
                return false;
            }

            return this.showSeries[id]
        },
        isScalingProfileVisible(scalingProfileId) {
            // Check if each series in this is hidden
            let allPointsHidden = true
            _.each(this.pointsByScalingProfile[scalingProfileId], point => {
                if (_.has(this.showSeries, point.id) && this.showSeries[point.id]) {
                    allPointsHidden = false
                }
            })

            return !allPointsHidden
        },
        updateShowSeries() {
            let search = this.search.toLowerCase()
            _.each(this.points, point => {
                let pointName = point.name.toLowerCase()
                let pointSerial = point.serialNumber.toLowerCase()
                this.showSeries[point.id] = (pointName.includes(search) || pointSerial.includes(search))
            })
        },
        rebuildPointsByScalingProfile() {
            this.pointsByScalingProfile = {}
            _.each(this.points, point => {
                if (!_.has(this.pointsByScalingProfile, point.scalingProfileId)) {
                    this.pointsByScalingProfile[point.scalingProfileId] = []
                }
                this.pointsByScalingProfile[point.scalingProfileId].push(point)
            })
        },
        showErrorMessage() {
            this.$data._modalScroll = 0
        },

        fathomGoalTrack(goal) {
            if (window.fathomLoaded && goal.length > 0) {
                window.fathom.trackGoal(goal, 0);
            }
        },

        fathomGoalTrackShowSeries() {
            this.fathomGoalTrack(am4Settings.FATHOM_GOALS.showSeries)
        },

        fathomGoalTrackAddSeries() {
            this.fathomGoalTrack(am4Settings.FATHOM_GOALS.addNewSeriesToPlot)
        },
    },
    computed: {
        hasPoints() {
            return !_.isNil(this.points)
        },
        hasScalingProfiles() {
            return !_.isNil(this.scalingProfiles)
        },
    },
    watch: {
        showModal(val, old) {
            // Do nothing if the value is the same
            if (val === old) {
                return
            }

            this.$data._show = val
            if (this.$data._show === true) {
                // Trigger tracking code on fathom
                this.fathomGoalTrackShowSeries()
            }

            // Reset points list and order them by scaling profile.
            this.resetPoints()
            this.rebuildPointsByScalingProfile()
        },
        seriesVisible: {
            handler(val, old) {
                this.resetPoints()
                this.rebuildPointsByScalingProfile()
            },
            deep: true
        },
        points() {
            this.resetPoints()
            this.rebuildPointsByScalingProfile()
        },
        search() {
            this.updateShowSeries()
        },
        errorMultipleScalingProfiles() {
            if (this.errorMultipleScalingProfiles) {
                this.showErrorMessage()
            }
        }
    },
}
</script>

<style scoped>

</style>